export const getIntervalString: (intervalAmount: any, intervalUnit: any, t: any) => string = (
  intervalAmount: any,
  intervalUnit: any,
  t: any,
): string => {
  let interval: string;
  switch (intervalUnit) {
    case "years":
      interval = intervalAmount < 2 ? t("yearly") : intervalAmount + " " + t("years");
      break;
    case "year":
      interval = intervalAmount < 2 ? t("yearly") : intervalAmount + " " + t("years");
      break;
    case "months":
      interval = intervalAmount < 2 ? t("monthly") : intervalAmount + " " + t("months");
      break;
    case "month":
      interval = intervalAmount < 2 ? t("monthly") : intervalAmount + " " + t("months");
      break;
    case "days":
      interval = intervalAmount < 2 ? t("daily") : intervalAmount + " " + t("days");
      break;
    case "day":
      interval = intervalAmount < 2 ? t("daily") : intervalAmount + " " + t("days");
      break;
    case "weeks":
      interval = intervalAmount < 2 ? t("weekly") : intervalAmount + " " + t("weeks");
      break;
    case "week":
      interval = intervalAmount < 2 ? t("weekly") : intervalAmount + " " + t("weeks");
      break;
    default:
      interval = t("one time");
      break;
  }
  return interval;
};

export const getIntervalMonthShort: (intervalUnit: any) => string = (intervalUnit: any): string => {
  let iV: string;
  switch (intervalUnit) {
    case "years":
      iV = "y";
      break;
    case "months":
      iV = "m";
      break;
    case "days":
      iV = "d";
      break;
    case "year":
      iV = "y";
      break;
    case "month":
      iV = "m";
      break;
    default:
      iV = "m";
      break;
  }
  return iV;
};

export const getMinDuration: (duration: number | null, t: any) => string = (
  duration: number | null,
  t: any,
): string => {
  if (duration === null) return "";
  if (duration % 31536000 === 0) return (duration / 31536000).toString() + " " + t("years");

  if (duration % 2592000 === 0) return (duration / 2592000).toString() + " " + t("months");

  if (duration % 604800 === 0) return (duration / 604800).toString() + " " + t("weeks");

  if (duration % 86400 === 0) return (duration / 86400).toString() + " " + t("days");
  return "";
};
